import { createContext, useState } from 'react';
import jwt_decode from "jwt-decode";

const AuthContext= createContext({});

export const AuthProvider =({children}) => {
    const [user, setUser] = useState(()=> sessionStorage.getItem('accessToken') ? jwt_decode(sessionStorage.getItem('accessToken')) : null);
    const [accessToken, setAccessToken]= useState(()=> window.sessionStorage.getItem('accessToken') ?  window.sessionStorage.getItem('accessToken'): null);
 
    return(
        <AuthContext.Provider value={{user,setUser,accessToken,setAccessToken}}>
            {children}
        </AuthContext.Provider>
    )
}

export default AuthContext;